import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      onEnd: this.end.bind(this),
    })
  }

  end(event) {
    const url = event.item.dataset.url
    const data = new FormData()
    data.append("position", event.newIndex + 1)
    const csrf = document.querySelector("[name='csrf-token']").content

    fetch(url, {
      method: "PATCH",
      body: data,
      headers: {
        "X-CSRF-Token": csrf,
      },
    })
  }

  book() {
    const id = this.scope.element.dataset.id
    const ele = document.getElementsByName(`completed_${id}`)

    if (ele[0] && ele[0].checked) return

    const elements = document.getElementsByClassName(`form_todo_${id}`)
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.toggle("hidden")
    }
  }
}
